import React from "react";
import Grid, { Col } from "../grid/Grid";
import Section from "../section/Section";
import PageLabel from "../pageLabel/PageLabel";
import Email from "../email/Email";
import * as styles from "./ContactBanner.module.css";

const ContactBanner = () => {
  return (
    <Section className={styles.contactBanner} padding="both" backgroundColor="blue" lightOnDark>
      <Grid>
        <Col start={1} span={12}>
          <PageLabel>Contact us</PageLabel>
          <h2 className="noTopMargin">Let’s see what we can create together</h2>
          <Email
            invert
          />
        </Col>
      </Grid>
    </Section>
  );
};

export default ContactBanner;
